export const pointreport = {
  namespaced: true,
  state: {
    selectedPoint:null,
    loadingAsync: false,
    syncProgress: {
      done: 0,
      total: 0,
      report: { done: 0, total: 0 },
      reportData: { done: 0, total: 0 },
    },
    loadingReport: false,
    duplicatesPhoto: []
  },
  getters: {
  },
  actions: {
    
  },
  mutations: {
    setSelectedPoint(state,point){
      state.selectedPoint = point
    },

    setLoadingAsync(state, loading) {
      state.loadingAsync = loading
    },

    setSyncProgress(state, progress) {
      state.syncProgress = progress
    },

    setLoadingReport(state, loading) {
      state.loadingReport = loading
    },

    setDuplicatesPhoto(state, photos) {
      state.duplicatesPhoto = state.duplicatesPhoto.concat(photos)
    },

    clearDublicatesPhoto(state) {
      state.duplicatesPhoto = []
    }
  }
}